import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { School, ChevronDown, ChevronUp, CheckCircle, Play, Clock, Book, Home, Award } from 'lucide-react';

// Dados simulados dos cursos
const cursosData = [
  {
    id: "fundamentos-fe",
    titulo: "Fundamentos da Fé",
    publico: "jovem",
    descricao: "Introdução à vida cristã para jovens.",
    imagem: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    aulas: [
      {
        id: 1,
        titulo: "Quem é Jesus Cristo?",
        conteudo: "Nesta aula, exploraremos a identidade de Jesus Cristo como o Filho de Deus e Salvador da humanidade. Estudaremos passagens bíblicas que revelam sua divindade, humanidade e missão redentora.",
        duracao: "25 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 2,
        titulo: "A Bíblia: A Palavra de Deus",
        conteudo: "Aprenda sobre a inspiração, autoridade e confiabilidade das Escrituras. Descubra como a Bíblia foi escrita, preservada e como ela continua relevante para nossas vidas hoje.",
        duracao: "30 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 3,
        titulo: "Salvação pela Graça",
        conteudo: "Entenda o conceito bíblico de salvação pela graça mediante a fé. Aprenda sobre a obra redentora de Cristo na cruz e como recebemos a salvação como um presente de Deus.",
        duracao: "28 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 4,
        titulo: "O Espírito Santo",
        conteudo: "Conheça a terceira pessoa da Trindade: o Espírito Santo. Aprenda sobre seu papel na vida do crente, seus dons e frutos, e como ser cheio do Espírito.",
        duracao: "32 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 5,
        titulo: "A Igreja",
        conteudo: "Descubra o propósito da igreja como corpo de Cristo. Entenda a importância da comunhão, do discipulado e da missão da igreja no mundo.",
        duracao: "27 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 6,
        titulo: "Oração e Comunhão com Deus",
        conteudo: "Aprenda princípios bíblicos sobre a oração e como desenvolver uma vida de comunhão com Deus. Descubra diferentes tipos de oração e como orar eficazmente.",
        duracao: "29 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 7,
        titulo: "Mordomia Cristã",
        conteudo: "Entenda o princípio bíblico de mordomia - administrar bem os recursos que Deus nos confiou, incluindo tempo, talentos e finanças.",
        duracao: "26 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 8,
        titulo: "Evangelismo e Missões",
        conteudo: "Aprenda sobre a Grande Comissão e a responsabilidade de cada cristão de compartilhar o evangelho. Descubra métodos práticos de evangelismo pessoal.",
        duracao: "31 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      }
    ],
    duracao: "4 semanas"
  },
  {
    id: "crescimento-espiritual",
    titulo: "Crescimento Espiritual",
    publico: "adulto",
    descricao: "Curso voltado ao amadurecimento espiritual.",
    imagem: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    aulas: [
      {
        id: 1,
        titulo: "Disciplinas Espirituais",
        conteudo: "Introdução às disciplinas espirituais clássicas como jejum, meditação, estudo bíblico e oração contemplativa. Aprenda como estas práticas podem aprofundar sua vida espiritual.",
        duracao: "35 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 2,
        titulo: "Vencendo Tentações",
        conteudo: "Estratégias bíblicas para identificar e superar tentações. Aprenda a reconhecer padrões de pensamento destrutivos e a aplicar a verdade bíblica para vencer.",
        duracao: "32 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 3,
        titulo: "Desenvolvendo o Caráter Cristão",
        conteudo: "Estudo sobre o fruto do Espírito e como cultivar qualidades como amor, alegria, paz, paciência, bondade, fidelidade, mansidão e domínio próprio.",
        duracao: "38 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 4,
        titulo: "Relacionamentos Saudáveis",
        conteudo: "Princípios bíblicos para construir e manter relacionamentos saudáveis na família, igreja e sociedade. Aprenda sobre perdão, comunicação eficaz e resolução de conflitos.",
        duracao: "34 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 5,
        titulo: "Discernimento Espiritual",
        conteudo: "Como desenvolver discernimento para tomar decisões sábias e alinhadas com a vontade de Deus. Aprenda a ouvir a voz de Deus em meio às muitas vozes do mundo.",
        duracao: "36 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 6,
        titulo: "Lidando com Sofrimento",
        conteudo: "Uma perspectiva bíblica sobre o sofrimento e as dificuldades da vida. Aprenda como Deus pode usar as provações para nosso crescimento e como encontrar esperança em tempos difíceis.",
        duracao: "40 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 7,
        titulo: "Adoração como Estilo de Vida",
        conteudo: "Entenda a adoração além da música, como um estilo de vida que honra a Deus em tudo o que fazemos. Aprenda a viver em constante atitude de adoração.",
        duracao: "30 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 8,
        titulo: "Mentoria e Discipulado",
        conteudo: "A importância de ter mentores espirituais e de discipular outros. Aprenda princípios práticos para estabelecer relacionamentos de mentoria eficazes.",
        duracao: "33 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 9,
        titulo: "Cosmovisão Cristã",
        conteudo: "Desenvolva uma visão de mundo baseada na Bíblia. Aprenda a analisar cultura, política, ciência e outras áreas da vida através de uma perspectiva cristã.",
        duracao: "37 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 10,
        titulo: "Maturidade Espiritual",
        conteudo: "Características da maturidade espiritual e como continuar crescendo ao longo da vida. Aprenda a avaliar seu crescimento e a estabelecer metas espirituais.",
        duracao: "35 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      }
    ],
    duracao: "6 semanas"
  },
  {
    id: "discipulado",
    titulo: "Discipulado",
    publico: "jovem",
    descricao: "Aprenda a ser um discípulo de Jesus e a fazer discípulos.",
    imagem: "https://images.unsplash.com/photo-1490730141103-6cac27aaab94?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    aulas: [
      {
        id: 1,
        titulo: "O Chamado para Seguir a Jesus",
        conteudo: "Explore o significado do chamado de Jesus para segui-lo e o que significa ser um discípulo nos dias de hoje.",
        duracao: "28 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 2,
        titulo: "Identidade em Cristo",
        conteudo: "Descubra quem você é em Cristo e como sua identidade como filho de Deus transforma sua vida e propósito.",
        duracao: "30 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 3,
        titulo: "Discipulado Relacional",
        conteudo: "Aprenda como Jesus discipulou seus seguidores e como podemos aplicar esses princípios em relacionamentos de discipulado hoje.",
        duracao: "25 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 4,
        titulo: "Compartilhando Sua Fé",
        conteudo: "Métodos práticos para compartilhar sua fé com amigos e familiares de maneira natural e eficaz.",
        duracao: "27 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 5,
        titulo: "Multiplicação de Discípulos",
        conteudo: "Estratégias para multiplicar discípulos e criar um movimento de discipulado em sua comunidade.",
        duracao: "32 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 6,
        titulo: "Vivendo em Comunidade",
        conteudo: "A importância da comunidade no processo de discipulado e como construir relacionamentos significativos.",
        duracao: "29 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      }
    ],
    duracao: "3 semanas"
  },
  {
    id: "lideranca-crista",
    titulo: "Liderança Cristã",
    publico: "adulto",
    descricao: "Desenvolva habilidades de liderança baseadas em princípios bíblicos.",
    imagem: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    aulas: [
      {
        id: 1,
        titulo: "Fundamentos da Liderança Cristã",
        conteudo: "Princípios bíblicos de liderança e como eles diferem dos modelos seculares. Estudo dos exemplos de líderes na Bíblia.",
        duracao: "35 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 2,
        titulo: "Liderança Servidora",
        conteudo: "O modelo de liderança de Jesus como servo. Como aplicar o princípio de servir primeiro e liderar depois.",
        duracao: "38 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 3,
        titulo: "Desenvolvendo Equipes",
        conteudo: "Estratégias para formar, desenvolver e liderar equipes eficazes no ministério.",
        duracao: "32 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 4,
        titulo: "Comunicação Eficaz",
        conteudo: "Habilidades de comunicação para líderes, incluindo pregação, ensino e comunicação interpessoal.",
        duracao: "34 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 5,
        titulo: "Resolução de Conflitos",
        conteudo: "Abordagens bíblicas para identificar, abordar e resolver conflitos em contextos de liderança.",
        duracao: "36 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 6,
        titulo: "Mentoria e Desenvolvimento de Líderes",
        conteudo: "Como identificar e desenvolver futuros líderes através de relacionamentos de mentoria intencionais.",
        duracao: "33 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 7,
        titulo: "Visão e Planejamento Estratégico",
        conteudo: "Como desenvolver e comunicar visão, estabelecer metas e criar planos estratégicos para o ministério.",
        duracao: "40 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 8,
        titulo: "Integridade e Caráter",
        conteudo: "A importância do caráter e da integridade na liderança cristã. Como manter a prestação de contas e a transparência.",
        duracao: "37 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 9,
        titulo: "Liderança em Tempos de Crise",
        conteudo: "Como liderar eficazmente durante períodos de mudança, incerteza e dificuldade.",
        duracao: "35 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 10,
        titulo: "Autocuidado e Sustentabilidade",
        conteudo: "Práticas para manter a saúde espiritual, emocional e física como líder. Prevenção de burnout e estabelecimento de limites saudáveis.",
        duracao: "30 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 11,
        titulo: "Liderança Transcultural",
        conteudo: "Princípios para liderar em contextos multiculturais e desenvolver sensibilidade cultural no ministério.",
        duracao: "32 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 12,
        titulo: "Legado de Liderança",
        conteudo: "Como construir um legado duradouro e preparar a transição de liderança para a próxima geração.",
        duracao: "39 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      }
    ],
    duracao: "8 semanas"
  },
  {
    id: "evangelismo",
    titulo: "Evangelismo Prático",
    publico: "jovem",
    descricao: "Métodos e estratégias para compartilhar o evangelho de forma eficaz.",
    imagem: "https://images.unsplash.com/photo-1519834089823-af2d966a0648?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    aulas: [
      {
        id: 1,
        titulo: "Fundamentos do Evangelismo",
        conteudo: "O que é evangelismo e por que é importante para todo cristão. Base bíblica para a evangelização.",
        duracao: "25 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 2,
        titulo: "Compartilhando Seu Testemunho",
        conteudo: "Como preparar e compartilhar sua história pessoal de fé de maneira impactante e relevante.",
        duracao: "28 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 3,
        titulo: "Evangelismo nas Redes Sociais",
        conteudo: "Estratégias para usar plataformas digitais para compartilhar o evangelho e engajar-se em conversas significativas sobre fé.",
        duracao: "26 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 4,
        titulo: "Respondendo a Perguntas Difíceis",
        conteudo: "Como responder com graça e verdade às perguntas e objeções comuns sobre a fé cristã.",
        duracao: "30 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 5,
        titulo: "Evangelismo Relacional",
        conteudo: "Como construir relacionamentos autênticos que abrem portas para compartilhar o evangelho naturalmente.",
        duracao: "27 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      }
    ],
    duracao: "3 semanas"
  },
  {
    id: "familia-crista",
    titulo: "Família Cristã",
    publico: "adulto",
    descricao: "Princípios bíblicos para construir uma família saudável e feliz.",
    imagem: "https://images.unsplash.com/photo-1511895426328-dc8714191300?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    aulas: [
      {
        id: 1,
        titulo: "Fundamentos Bíblicos para a Família",
        conteudo: "O plano de Deus para a família desde a criação. Princípios bíblicos fundamentais para relacionamentos familiares saudáveis.",
        duracao: "32 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 2,
        titulo: "Casamento Centrado em Cristo",
        conteudo: "Como construir e manter um casamento que honra a Deus. Papéis, comunicação e intimidade no casamento cristão.",
        duracao: "35 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 3,
        titulo: "Criação de Filhos",
        conteudo: "Princípios bíblicos para educar filhos no caminho do Senhor. Disciplina, instrução e modelagem de fé.",
        duracao: "38 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 4,
        titulo: "Finanças Familiares",
        conteudo: "Administração financeira segundo princípios bíblicos. Orçamento, dívidas, generosidade e contentamento.",
        duracao: "30 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 5,
        titulo: "Resolução de Conflitos Familiares",
        conteudo: "Estratégias bíblicas para resolver conflitos, buscar reconciliação e fortalecer relacionamentos familiares.",
        duracao: "33 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 6,
        titulo: "Famílias Mistas e Reconstituídas",
        conteudo: "Desafios e oportunidades em famílias mistas. Como construir unidade e estabelecer relacionamentos saudáveis.",
        duracao: "34 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 7,
        titulo: "Legado Espiritual",
        conteudo: "Como transmitir valores e fé para as próximas gerações. Criando tradições familiares significativas.",
        duracao: "31 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      },
      {
        id: 8,
        titulo: "Família como Testemunho",
        conteudo: "Como sua família pode ser um testemunho do evangelho para a comunidade. Hospitalidade e ministério familiar.",
        duracao: "29 min",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      }
    ],
    duracao: "5 semanas"
  }
];

// Interface para o progresso do curso
interface ProgressoCurso {
  aulasAssistidas: number[];
  ultimaAula?: number;
}

export default function CursoDetalhe() {
  const { cursoId } = useParams<{ cursoId: string }>();
  const navigate = useNavigate();
  const [curso, setCurso] = useState<any>(null);
  const [progresso, setProgresso] = useState<ProgressoCurso>({ aulasAssistidas: [] });
  const [loading, setLoading] = useState(true);
  const [expandedAula, setExpandedAula] = useState<number | null>(null);
  const [activeTab, setActiveTab] = useState<'conteudo' | 'material' | 'forum'>('conteudo');

  useEffect(() => {
    // Buscar dados do curso pelo ID
    const cursoEncontrado = cursosData.find(c => c.id === cursoId);
    if (cursoEncontrado) {
      setCurso(cursoEncontrado);
    }

    // Carregar progresso do curso
    const carregarProgresso = () => {
      try {
        const progressoString = localStorage.getItem(`progresso_${cursoId}`);
        if (progressoString) {
          setProgresso(JSON.parse(progressoString));
        }
      } catch (error) {
        console.error('Erro ao carregar progresso:', error);
      } finally {
        setLoading(false);
      }
    };

    carregarProgresso();
  }, [cursoId]);

  const marcarAulaComoAssistida = (aulaId: number) => {
    try {
      const novasAulasAssistidas = [...progresso.aulasAssistidas];
      if (!novasAulasAssistidas.includes(aulaId)) {
        novasAulasAssistidas.push(aulaId);
      }
      
      const novoProgresso = {
        aulasAssistidas: novasAulasAssistidas,
        ultimaAula: aulaId
      };
      
      localStorage.setItem(`progresso_${cursoId}`, JSON.stringify(novoProgresso));
      setProgresso(novoProgresso);
      
      // Verificar se todas as aulas foram assistidas
      if (curso && novasAulasAssistidas.length === curso.aulas.length) {
        if (window.confirm("Parabéns! Você completou todas as aulas deste curso. Deseja fazer a avaliação final?")) {
          navigate('/cursos/avaliacao');
        }
      }
    } catch (error) {
      console.error('Erro ao salvar progresso:', error);
      alert("Erro ao salvar progresso. Por favor, tente novamente.");
    }
  };

  const calcularProgresso = (): number => {
    if (!curso) return 0;
    return Math.round((progresso.aulasAssistidas.length / curso.aulas.length) * 100);
  };

  const toggleAula = (aulaId: number) => {
    setExpandedAula(expandedAula === aulaId ? null : aulaId);
  };

  const getYouTubeEmbedUrl = (url: string) => {
    const videoId = url.split('v=')[1]?.split('&')[0];
    if (!videoId) return '';
    return `https://www.youtube.com/embed/${videoId}`;
  };

  if (loading || !curso) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-teal"></div>
      </div>
    );
  }

  const percentualProgresso = calcularProgresso();
  const todasAulasAssistidas = progresso.aulasAssistidas.length === curso.aulas.length;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <School className="h-8 w-8 text-brand-teal" />
          <h1 className="text-3xl font-bold text-brand-teal">{curso.titulo}</h1>
        </div>
        <button
          onClick={() => navigate('/cursos')}
          className="flex items-center gap-2 px-4 py-2 bg-brand-teal text-white rounded-lg hover:bg-brand-teal/90 transition-colors"
        >
          <Home className="h-4 w-4" />
          <span>Voltar para Cursos</span>
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Coluna da esquerda - Informações do curso */}
        <div className="lg:col-span-1">
          <div className="bg-white rounded-xl overflow-hidden shadow-elevation-1">
            <img 
              src={curso.imagem} 
              alt={curso.titulo} 
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <h2 className="text-xl font-semibold text-gray-900">{curso.titulo}</h2>
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                  curso.publico === 'jovem' ? 'bg-blue-100 text-blue-600' : 'bg-indigo-100 text-indigo-600'
                }`}>
                  {curso.publico === 'jovem' ? 'Jovem' : 'Adulto'}
                </span>
              </div>
              <p className="text-gray-600 mb-4">{curso.descricao}</p>
              <div className="space-y-3 mb-6">
                <div className="flex items-center gap-2">
                  <Book className="h-5 w-5 text-brand-teal" />
                  <span className="text-gray-700">{curso.aulas.length} aulas</span>
                </div>
                <div className="flex items-center gap-2">
                  <Clock className="h-5 w-5 text-brand-teal" />
                  <span className="text-gray-700">Duração: {curso.duracao}</span>
                </div>
              </div>

              {/* Barra de progresso */}
              <div className="mb-6">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-medium text-gray-700">Seu progresso</span>
                  <span className="text-sm font-medium text-brand-teal">{percentualProgresso}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                  <div 
                    className="bg-brand-teal h-2.5 rounded-full" 
                    style={{ width: `${percentualProgresso}%` }}
                  ></div>
                </div>
                <p className="text-sm text-gray-500 mt-2">
                  {progresso.aulasAssistidas.length} de {curso.aulas.length} aulas concluídas
                </p>
              </div>

              {/* Botão de avaliação final */}
              {todasAulasAssistidas && (
                <button 
                  onClick={() => navigate('/cursos/avaliacao')}
                  className="w-full bg-brand-teal text-white py-3 px-4 rounded-lg hover:bg-brand-teal/90 transition-colors flex items-center justify-center gap-2"
                >
                  <Award className="h-5 w-5" />
                  <span>Fazer Avaliação Final</span>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Coluna da direita - Conteúdo do curso */}
        <div className="lg:col-span-2">
          {/* Tabs de navegação */}
          <div className="flex border-b border-gray-200 mb-6">
            <button
              onClick={() => setActiveTab('conteudo')}
              className={`px-4 py-2 font-medium text-sm ${
                activeTab === 'conteudo'
                  ? 'text-brand-teal border-b-2 border-brand-teal'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              Conteúdo do Curso
            </button>
            <button
              onClick={() => setActiveTab('material')}
              className={`px-4 py-2 font-medium text-sm ${
                activeTab === 'material'
                  ? 'text-brand-teal border-b-2 border-brand-teal'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              Material de Estudo
            </button>
            <button
              onClick={() => setActiveTab('forum')}
              className={`px-4 py-2 font-medium text-sm ${
                activeTab === 'forum'
                  ? 'text-brand-teal border-b-2 border-brand-teal'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              Fórum de Discussão
            </button>
          </div>

          {/* Conteúdo da tab ativa */}
          {activeTab === 'conteudo' && (
            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">Aulas do Curso</h2>
              
              {curso.aulas.map((aula: any) => (
                <div 
                  key={aula.id}
                  className="bg-white rounded-xl shadow-sm overflow-hidden"
                >
                  <div 
                    className="p-4 flex justify-between items-center cursor-pointer hover:bg-gray-50"
                    onClick={() => toggleAula(aula.id)}
                  >
                    <div className="flex items-center gap-4">
                      <div className="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 font-medium">
                        {aula.id}
                      </div>
                      <div>
                        <h3 className="font-medium text-gray-900">{aula.titulo}</h3>
                        <p className="text-sm text-gray-500">{aula.duracao}</p>
                      </div>
                    </div>
                    <div className="flex items-center">
                      {progresso.aulasAssistidas.includes(aula.id) && (
                        <span className="mr-2 text-green-500">
                          <CheckCircle className="h-5 w-5" />
                        </span>
                      )}
                      {expandedAula === aula.id ? (
                        <ChevronUp className="h-5 w-5 text-gray-400" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-gray-400" />
                      )}
                    </div>
                  </div>
                  
                  {expandedAula === aula.id && (
                    <div className="p-4 pt-0 border-t border-gray-100">
                      <p className="text-gray-600 mb-4">{aula.conteudo}</p>
                      
                      {/* Vídeo da aula */}
                      <div className="aspect-video w-full mb-4 bg-gray-100 rounded-lg overflow-hidden">
                        <iframe
                          src={getYouTubeEmbedUrl(aula.videoUrl)}
                          title={aula.titulo}
                          className="w-full h-full"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                      
                      <button
                        onClick={() => marcarAulaComoAssistida(aula.id)}
                        className={`flex items-center justify-center gap-2 px-4 py-2 rounded-lg ${
                          progresso.aulasAssistidas.includes(aula.id)
                            ? 'bg-green-500 text-white'
                            : 'bg-brand-teal text-white hover:bg-brand-teal/90'
                        } transition-colors`}
                      >
                        {progresso.aulasAssistidas.includes(aula.id) ? (
                          <>
                            <CheckCircle className="h-4 w-4" />
                            <span>Aula Concluída</span>
                          </>
                        ) : (
                          <>
                            <Play className="h-4 w-4" />
                            <span>Marcar como Concluída</span>
                          </>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {activeTab === 'material' && (
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">Material de Estudo</h2>
              <p className="text-gray-600 mb-6">
                Aqui você encontra materiais complementares para aprofundar seus estudos.
              </p>
              
              <div className="space-y-4">
                <div className="p-4 border border-gray-200 rounded-lg flex justify-between items-center">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-blue-100 rounded-lg">
                      <Book className="h-5 w-5 text-blue-600" />
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-900">Apostila do Curso</h3>
                      <p className="text-sm text-gray-500">PDF • 2.4 MB</p>
                    </div>
                  </div>
                  <button className="text-brand-teal hover:text-brand-teal/80">
                    Download
                  </button>
                </div>
                
                <div className="p-4 border border-gray-200 rounded-lg flex justify-between items-center">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-green-100 rounded-lg">
                      <Book className="h-5 w-5 text-green-600" />
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-900">Guia de Estudos</h3>
                      <p className="text-sm text-gray-500">PDF • 1.8 MB</p>
                    </div>
                  </div>
                  <button className="text-brand-teal hover:text-brand-teal/80">
                    Download
                  </button>
                </div>
                
                <div className="p-4 border border-gray-200 rounded-lg flex justify-between items-center">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-purple-100 rounded-lg">
                      <Book className="h-5 w-5 text-purple-600" />
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-900">Referências Bibliográficas</h3>
                      <p className="text-sm text-gray-500">PDF • 0.5 MB</p>
                    </div>
                  </div>
                  <button className="text-brand-teal hover:text-brand-teal/80">
                    Download
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'forum' && (
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">Fórum de Discussão</h2>
              <p className="text-gray-600 mb-6">
                Participe das discussões sobre o conteúdo do curso com outros alunos.
              </p>
              
              <div className="space-y-6">
                <div className="p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-start gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-brand-light text-brand-teal flex items-center justify-center font-medium">
                      JS
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-900">João Silva</h3>
                      <p className="text-sm text-gray-500">Há 2 dias</p>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-4">
                    Estou com uma dúvida sobre a aula 3. Quando falamos sobre salvação pela graça, como podemos conciliar isso com a importância das boas obras mencionada em Tiago?
                  </p>
                  <div className="flex justify-end">
                    <button className="text-brand-teal hover:text-brand-teal/80 text-sm">
                      Responder
                    </button>
                  </div>
                </div>
                
                <div className="p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-start gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-brand-light text-brand-teal flex items-center justify-center font-medium">
                      MS
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-900">Maria Santos</h3>
                      <p className="text-sm text-gray-500">Há 5 dias</p>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-4">
                    Gostei muito da aula sobre o Espírito Santo. Alguém tem recomendações de livros para aprofundar nesse tema?
                  </p>
                  <div className="flex justify-end">
                    <button className="text-brand-teal hover:text-brand-teal/80 text-sm">
                      Responder
                    </button>
                  </div>
                </div>
                
                <div className="mt-6">
                  <h3 className="font-medium text-gray-900 mb-3">Iniciar nova discussão</h3>
                  <textarea
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-teal focus:border-brand-teal"
                    rows={4}
                    placeholder="Escreva sua pergunta ou comentário..."
                  ></textarea>
                  <div className="flex justify-end mt-3">
                    <button className="bg-brand-teal text-white px-4 py-2 rounded-lg hover:bg-brand-teal/90 transition-colors">
                      Publicar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}